(function () {
  'use strict';
  var nextId = 0;
  var scheduled = false;

  function moveSizeChart(root) {
    root.querySelectorAll('.sizechart-trigger').forEach(function (trigger) {
      if (trigger.closest('.product-size-options')) return;
      var meta = trigger.closest('.product-single__meta');
      if (!meta) return;
      var wrapper = Array.from(meta.querySelectorAll('.variant-wrapper')).find(function (candidate) {
        var field = candidate.querySelector('fieldset, select');
        var label = candidate.querySelector('.variant__label');
        return field && label && /^(size|gr[o\u00f6]sse|gr[o\u00f6]\u00dfe)$/i.test(
          (field.getAttribute('data-handle') || field.getAttribute('name') || label.textContent).trim()
        );
      });
      if (!wrapper) return;
      var field = wrapper.querySelector('.variant-input-wrap');
      if (!field) return;
      var label = wrapper.querySelector('.variant__label');
      var originalBlock = trigger.closest('.product-block');
      var row = document.createElement('div');
      row.className = 'product-size-options';
      label.before(row);
      var heading = document.createElement('div');
      heading.className = 'product-size-heading';
      row.appendChild(heading);
      heading.appendChild(label);
      row.appendChild(field);
      // Reuse the actual link so the existing lightbox listener stays attached.
      heading.appendChild(trigger);
      if (!trigger.querySelector('svg')) {
        var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 64 64');
        icon.setAttribute('class', 'icon icon-size-chart');
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M22.39 33.53c-7.46 0-13.5-3.9-13.5-8.72s6-8.72 13.5-8.72 13.5 3.9 13.5 8.72 M8.89 24.81V38.5c0 7.9 6.4 9.41 14.3 9.41h31.92V33.53H22.39m24.39 0v7.44m-8.13-7.44v7.44m-8.13-7.44v7.44m-8.13-7.44v7.44');
        icon.appendChild(path);
        trigger.prepend(icon);
      }
      if (originalBlock && originalBlock !== wrapper.closest('.product-block')) {
        originalBlock.classList.add('product-block--sizechart-moved');
      }
    });
  }

  function initializeDescriptions(root) {
    root.querySelectorAll('[data-product-description]').forEach(function (description) {
      if (description.dataset.readMoreInitialized) return;
      var content = description.querySelector('[data-product-description-content]');
      if (!content || !content.textContent.trim()) return;
      var first = content.firstElementChild;
      var meta = description.closest('.product-single__meta');
      var title = meta && meta.querySelector('.product-single__title');
      var productName = title && title.textContent.split('|')[0].replace(/\s+/g, ' ').trim();
      if (first && first.tagName === 'P' && productName &&
          first.textContent.trim().startsWith(productName) && first.textContent.trim().length <= 180) {
        first.classList.add('product-description__heading');
      }
      var preview = content.cloneNode(true);
      preview.removeAttribute('id');
      preview.removeAttribute('data-product-description-content');
      preview.classList.add('product-description__preview');
      preview.querySelectorAll('script, style, template').forEach(function (element) { element.remove(); });
      preview.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
      description.prepend(preview);
      if (preview.scrollHeight <= preview.clientHeight + 2) {
        preview.remove();
        return;
      }
      // The excerpt is decorative; only the full text keeps interactive links.
      preview.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
        element.setAttribute('tabindex', '-1');
      });
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'product-description__toggle';
      content.id = 'product-description-read-more-' + (++nextId);
      toggle.setAttribute('aria-controls', content.id);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = description.dataset.moreLabel || 'Show more';
      content.hidden = true;
      description.appendChild(toggle);
      description.dataset.readMoreInitialized = 'true';
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') !== 'true';
        preview.hidden = expanded;
        content.hidden = !expanded;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? (description.dataset.lessLabel || 'Show less') : (description.dataset.moreLabel || 'Show more');
        if (!expanded && toggle.getBoundingClientRect().top < 0) {
          toggle.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      });
    });
  }

  function initialize() {
    scheduled = false;
    moveSizeChart(document);
    initializeDescriptions(document);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule);
}());
